import { DotLottie } from "@lottiefiles/dotlottie-web";

export default function initLottie() {
  // Get all elements with the class 'js-lottie'
  const lottieElements = document.querySelectorAll(".js-lottie");

  // Create an Intersection Observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const elem = entry.target;

          // Create a new DotLottie instance when element is visible
          const dotLottie = new DotLottie({
            autoplay: true,
            loop: false,
            canvas: elem,
            src: elem.getAttribute("data-src"),
          });

          // Store the instance on the element for potential future reference
          elem.dotLottieInstance = dotLottie;

          // Unobserve the element after initializing Lottie
          observer.unobserve(elem);
        }
      });
    },
    {
      // Start loading when element is 20% visible
      threshold: 0.2,
      // Start loading when element is 50px from viewport
      rootMargin: "50px",
    },
  );

  // Observe each Lottie element
  lottieElements.forEach((elem) => {
    observer.observe(elem);
  });
}
